import packageCollectionContractAbi from "@/abis/package-collection.abi.json"

export const packageCollectionContractConfig = {
  address: process.env.REACT_APP_PACKAGE_COLLECTION_CONTRACT_ADDRESS!,
  abi: packageCollectionContractAbi,
}
